import toFormData from "./toFormData";
import downloadByUrl from "./downloadByUrl";

export default {
  getBaseUrl() {
    return process.env.NODE_ENV === "development" ? "proxy" : "";
  },
  toFormData,
  downloadByUrl
};
